import React from 'react'
import classes from "./Business.module.css";
import bigcirlce from "../../Assets/bigcircle.svg"
import smallcirlce from "../../Assets/smallcircle.svg"
import promix from "../../Assets/Promix.svg"
import authimg from "../../Assets/authimg.png";
import cal from "../../Assets/calculate.svg"
import accend from "../../Assets/accend.svg"
import corporate from "../../Assets/corporate.svg"
import smallsquare from "../../Assets/smallsquare.svg"
import bigsquare from "../../Assets/bigsquare.svg"
import eye from "../../Assets/eye.svg"
import picor from "../../Assets/picor.svg"
import note from "../../Assets/note.svg"
import mil from "../../Assets/mil.svg"
import morter from "../../Assets/morter.svg"
import blue from "../../Assets/blue.svg"
import move from "../../Assets/move.svg"
import { Link } from 'react-router';



const BusinessSetup = () => {
    return (
        <div>
            <div className={classes.main}>
                <div className={classes.leftside}>

                    <div className={classes.grit}>
                        <img src={promix} className={classes.pro} />
                        <p className={classes.fir_txt}>
                            <span className={classes.fir_txtRest}>Smart </span>
                            <span className={classes.fir_txtAccent}>Accounting</span>
                            <span className={classes.fir_txtRest}> for Nigerian Businesses</span>
                        </p>
                        <p className={classes.sec_txt}>
                            Trusted by SMEs across Nigeria to manage their finances smarter
                        </p>

                        <div>
                            <img src={authimg} className={classes.authimgleft} />
                        </div>
                    </div>
                </div>


                <div className={classes.right}>
                    <div className={classes.protw}>
                        <p className={classes.cre_top}>Business Setup</p>
                        <p className={classes.adkt}>Provide business details to continue.</p>
                        {/* <p className={classes.adkt}>Tell us about your business to get started.</p> */}
                    </div>



                    <div className={classes.portned}>

                        <div>


                            <div className={classes.james}>
                                <label className={classes.lab_el}>Currency</label>
                                <select
                                    className={classes.printer}
                                >
                                    <option value="" disabled selected>Select Currency</option>
                                    <option value="male">Intrnational</option>
                                    <option value="female">Local/National</option>
                                </select>
                            </div>
                            <div className={classes.james}>
                                <label className={classes.lab_el}>Account Method</label>
                                <select
                                    className={classes.printer}
                                >
                                    <option value="" disabled selected>Select Account Method</option>
                                    <option value="male">United Kingdom</option>
                                    <option value="female">Russia</option>
                                </select>
                            </div>

                            {/* <div className={classes.james}>
                                <label className={classes.lab_el}>VAT</label>
                                <select
                                    className={classes.printer}
                                >
                                    <option value="" disabled selected>Select States of operation</option>
                                    <option value="male">United Kingdom</option>
                                    <option value="female">Russia</option>
                                </select>
                            </div> */}
                        </div>


                        <div>


                            <div className={classes.james}>
                                <label className={classes.lab_el}>Financial Year</label>
                                <select
                                    className={classes.printer}
                                >
                                    <option value="" disabled selected>Select Year</option>
                                    <option value="male">United Kingdom</option>
                                    <option value="female">Russia</option>
                                </select>
                            </div>



                            <div className={classes.james}>
                                <label className={classes.lab_el}>VAT Registered</label>
                                <select
                                    className={classes.printer}
                                >
                                    <option value="" disabled selected>Select Option</option>
                                    <option value="male">Yes</option>
                                    <option value="female">No</option>
                                </select>
                            </div>



                        </div>



                    </div>
                    <div>
                        <div className={classes.james}>
                            <label className={classes.lab_el}>VAT Rate</label>
                            <select
                                className={classes.printer} style={{width: "100%"}}
                            >
                                <option value="" disabled selected>Select Vat Rate</option>
                                <option value="male">United Kingdom</option>
                                <option value="female">Russia</option>
                            </select>
                        </div>
                    </div>
                    <div className={classes.joshe}>
                        <div className={classes.pintoe}>
                            <input type='checkbox' className={classes.shipet} />
                            <p className={classes.abode}>By continuing, you agree to  <span className={classes.crit}> our Terms of Service and Privacy Policy</span> </p>
                        </div>
                    </div>

                    <Link to="/pricing-new"><button className={classes.sign}><span>Continue</span>
                        <span><img src={move} /></span>
                    </button></Link>

                </div>

            </div>
        </div>
    )
}

export default BusinessSetup
